export class UserProfile {
    init () {

        let userTopicOfInterestFormHandler = function () {
            let form = $('form#profile-topics-of-interest'),
                responseBox = document.getElementById('responseBox');

            form.find('input').each(function (input) {
                $(this).on('change', function () {
                    let url = form.attr('action');
                    let topicId = $(this).val();
                    let payload = {
                        'topic_id': topicId,
                        'interested': true
                    };

                    if(!this.checked) {
                        payload.interested = false;
                    }

                    $.ajax({
                        type: "POST",
                        url,
                        data: payload
                    }).success(function(response) {
                        responseBox.classList = 'success';
                        responseBox.innerHTML = response.result;
                        $(responseBox).fadeIn(function() {
                            setTimeout(function() {
                                $(responseBox).fadeOut();
                            }, 5000);
                        });
                    })
                })
            });
        }


        userTopicOfInterestFormHandler();
        $(document).ready(() => {
            if(!document.body.classList.contains('profile') && document.getElementById('responseBox')){
                $('#responseBox').fadeIn();
                setTimeout(() => {
                    $('#responseBox').fadeOut()
                }, 5000);
            }
        })
    }
}